export default __webpack_public_path__ + "static/media/theme_juletid.8fa00163.jpg";